import { render, staticRenderFns } from "./trend.vue?vue&type=template&id=86eb72de&scoped=true"
import script from "./trend.vue?vue&type=script&lang=js"
export * from "./trend.vue?vue&type=script&lang=js"
import style0 from "./trend.vue?vue&type=style&index=0&id=86eb72de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86eb72de",
  null
  
)

export default component.exports